import { Box, Skeleton } from "@mui/material";
import {
  type DetailedHTMLProps,
  type FC,
  type ImgHTMLAttributes,
  type SyntheticEvent,
  useState,
} from "react";

export interface SkeletonImageProps
  extends DetailedHTMLProps<
    ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {}

/**
 * Renders the skeleton as an absolute overlay on top of the `<img>` instead
 * of a flow sibling, so a partially-decoded image never shows through next
 * to (or behind) the skeleton while it's still downloading. `loading`
 * defaults to `true` whenever a `src`/`srcSet` is given — it only starts
 * `false` when neither is set, since there's nothing to wait on.
 */
export const SkeletonImage: FC<SkeletonImageProps> = (props) => {
  const [loading, setLoading] = useState(
    props.src !== undefined || props.srcSet !== undefined,
  );
  const onImageLoad = (e: SyntheticEvent<HTMLImageElement>) => {
    setLoading(false);
    props.onLoad?.(e);
  };
  return (
    <Box position="relative" width={props.width} height={props.height}>
      <img alt={props.alt} {...props} onLoad={onImageLoad} />
      {loading && (
        <Skeleton
          variant="rectangular"
          width={props.width}
          height={props.height}
          style={props.style}
          sx={{ position: "absolute", top: 0, left: 0 }}
        />
      )}
    </Box>
  );
};
